<template>
  <fieldset
    class="verification-controls">
    <legend>
      <span>
        Verifikation
      </span>
    </legend>
    <div
      class="content">
      <v-checkbox
        v-model="statusValue"
        :readonly="readonly" />
      <v-menu
        left
        bottom
        nudge-top="20"
        nudge-right="20"
        content-class="menu-verification-comment"
        :close-on-content-click="false"
        v-model="isCommentMenuActive">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :color="renderCommentIconColor">
            <v-icon>
              mdi-comment-outline
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-text-field
              outlined
              dense
              v-model="commentValue"
              label="Bemerkung"
              :readonly="readonly"
              v-on:keyup.enter="applyComment"
              ref="comment" />
              <v-btn
                color="primary"
                depressed
                @click="applyComment">
                Ok
              </v-btn>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'QuestionVerification',

  props: {
    question: {
      type: Object,
      default: void 0,
      required: true
    },

    answer: {
      type: Object,
      default: void 0
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    statusValue () {
      this.emitVerificationUpdateEvent()
    },

    isCommentMenuActive (val) {
      val
        ? setTimeout(_ => {
          this.$refs.comment.focus()
        }, 100)
        : void 0
    }
  },

  data () {
    return {
      statusValue: this.answer && this.answer.verification
        ? this.answer.verification.status
        : false,
      commentValue: this.answer && this.answer.verification
        ? this.answer.verification.comment
        : void 0,
      isCommentMenuActive: false
    }
  },

  computed: {
    renderCommentIconColor () {
      return this.commentValue
        ? 'primary'
        : void 0
    }
  },

  methods: {
    applyComment () {
      this.isCommentMenuActive = false

      this.readonly
        ? void 0
        : this.emitVerificationUpdateEvent()
    },

    emitVerificationUpdateEvent () {
      this.$emit('update-answer-verification', this.statusValue, this.commentValue)
    }
  }
}
</script>

<style lang="scss">
  .verification-controls {
    // background: #f5f5f5;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 1em;
    height: 56px;
    position: relative;
    width: 8em;

    > legend {
      position: absolute;
      font-size: 16px;
      left: -0.15em;
      top: -0.75em;
      transform: scale(0.75);
      padding: 0 0.3em;
      background: white; // cheating!
    }

    > .content {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 100%;

      > .v-input--checkbox {
        margin-right: 0.7em;
      }

      > .v-btn {
        margin-top: -0em;
      }
    }
  }

  .menu-verification-comment {
    box-shadow: 0 16px 32px rgba(0,0,0,0.1);
    width: 480px;

    .v-card {
      .v-card__text {
        display: flex;
        align-items: center;

        .v-text-field {
          margin-bottom: 0;
          margin-right: 1em;

          .v-input__slot {
            margin-bottom: 0;
          }

          .v-text-field__details {
            display: none;
          }
        }
      }
    }
  }
</style>
